import * as React from 'react';
import * as Cookies from "js-cookie";

import {Row, Col, Tabs, notification} from 'antd';

import CourseInfo from "./CourseInfo";
import Feedbacks from './Feedbacks';
import MaterialForm from './MaterialForm';
import Materials from './Materials';

import './Course.css';
import FormModal from "../../components/FormModal/FormModal";
import FeedbackForm from "./FeedbackForm";
import {gaFeedbacksTabClicked, gaMaterialsTabClicked} from '../../ga/course';

const TabPane = Tabs.TabPane;


interface IProps {
  match: any
}

export default class Course extends React.Component<IProps, {}> {

  callback = (key: string) => {
    key === 'feedbacks' ? gaFeedbacksTabClicked() : gaMaterialsTabClicked();
  };

  componentDidMount() {
    // show new feature notification about chat only once
    const isUserSeenChatNotification = Cookies.get('chatNotificationSeen');
    if (!isUserSeenChatNotification) {
      notification.open({
        message: 'New feature',
        description: 'Join course chat and discuss with your classmates',
      });
      Cookies.set('chatNotificationSeen', '1');
    }
  }

  public render() {
    const courseSlug: string = this.props.match.params.courseSlug;

    return(
      <div className='main-section'>
        <Row gutter={16}>

          <Col span={18}>
            <div className='content'>
              <CourseInfo courseSlug={courseSlug} />

              <Tabs defaultActiveKey='1' onChange={this.callback}>
                <TabPane tab='Feedbacks' key='feedbacks'>
                  <Feedbacks courseSlug={courseSlug} />
                </TabPane>
                <TabPane tab='Materials' key='materials'>
                  <Materials courseSlug={courseSlug} />
                </TabPane>
              </Tabs>

            </div>
          </Col>

          <Col span={6} className='content'>
            <div className='course-actions'>
              <FormModal buttonText='Write Feedback'
                         formComponent={<FeedbackForm courseSlug={courseSlug}/>}
              />

              <FormModal buttonText='Upload Material'
                         formComponent={<MaterialForm courseSlug={courseSlug} />}
              />

            </div>
          </Col>

        </Row>
      </div>
    )
  }
}